<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedLoading() {
      return !this.loading
    },
  },
}
</script>

<template>
  <v-container :class="{ displayLoading: computedLoading }">
    <v-overlay>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
@import '@design';

.loadingIcon {
  @extend %typography-xxlarge;

  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
.displayLoading {
  display: none !important;
}
</style>
